import Marquee from '../components/Marquee';
import { useLanguage } from '../i18n/LanguageContext';
import { reviewContent } from '../i18n/content/review';

import rev1 from '../assets/review/rev1.webp';
import rev2 from '../assets/review/rev2.webp';
import rev3 from '../assets/review/rev3.webp';
import rev4 from '../assets/review/rev4.webp';
import rev5 from '../assets/review/rev5.webp';
import rev6 from '../assets/review/rev6.webp';
import rev7 from '../assets/review/rev7.webp';

const REVIEW_IMAGES = [rev1, rev2, rev3, rev4, rev5, rev6, rev7];

const renderStars = (rating) => (
    Array.from({ length: 5 }, (_, index) => (
        <svg
            key={index}
            className={`w-5 h-5 ${index < rating ? 'text-primary' : 'text-line'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
        >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
    ))
);

export default function Review(){
    const { lang } = useLanguage();
    const c = reviewContent[lang];
    const reviews = c.reviews.map((r, i) => ({ id: i + 1, image: REVIEW_IMAGES[i], rating: 5, ...r }));
    return (
        <section className="about-section section2" style={{backgroundColor: 'var(--bg-color)'}}>
            <div className="main-content">
                <div className="text-center max-w-2xl mx-auto mb-10">
                    <h2 className="font-bold text-ink leading-tight mb-4" style={{ fontSize: 'clamp(1.85rem, 1.3rem + 2.2vw, 3rem)' }}>
                        {c.title}
                    </h2>
                    <div className="flex items-center justify-center gap-2 flex-wrap">
                        <div className="flex items-center gap-1">
                            {renderStars(5)}
                        </div>
                        <p className="text-ink-muted font-medium">{c.ratingLine}</p>
                    </div>
                </div>

                <Marquee
                    items={reviews}
                    duration={48}
                    className="py-6"
                    renderItem={(r) => (
                        <div className="bg-surface rounded-card-lg shadow-lg p-6 border border-line flex flex-col w-[280px] sm:w-[320px] h-[440px]">
                            <div className="flex items-center gap-1 mb-4">
                                {renderStars(r.rating)}
                            </div>
                            <div className="rounded-card-md overflow-hidden shadow-sm mb-4 aspect-[4/3]">
                                <img src={r.image} alt="" loading="lazy" className="w-full h-full object-cover" />
                            </div>
                            <blockquote className="text-ink italic mb-4 leading-relaxed line-clamp-3">
                                "{r.text}"
                            </blockquote>
                            <div className="mt-auto">
                                <p className="font-bold text-ink">{r.name}</p>
                                <p className="text-ink-muted text-sm">{r.location}</p>
                            </div>
                        </div>
                    )}
                />
            </div>
        </section>
    )
}
